import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { getUserSchema } from '@plone/volto/actions/userschema/userschema';
import { getVocabulary } from '@plone/volto/actions/vocabularies/vocabularies';
import { default as Unauthorized } from '@plone/volto/components/theme/Unauthorized/Unauthorized';
import { default as Forbidden } from '@plone/volto/components/theme/Forbidden/Forbidden';

import { Helmet } from '@plone/volto/helpers/Helmet/Helmet';
import { isManager } from '@plone/volto/helpers/User/User';

import { STATUS_VOCABULARY_ID } from '../../../constants';
import { Manager } from './Manager';
import { User } from './User';

import jwtDecode from 'jwt-decode';
import cx from 'classnames';

const PrivateAreaView = ({ location, staticContext }) => {
  /** state selectors **/
  const token = useSelector((state) => state.userSession.token);
  const user = useSelector((state) => state.users.user);
  const userId = token ? jwtDecode(token).sub : '';
  const isLoggedIn = !!userId;
  const dispatch = useDispatch();
  const intl = useIntl();

  const messages = defineMessages({
    adminPanel: {
      id: 'adminPanel',
      defaultMessage: 'Admin panel',
    },
    adminPanelHelmet: {
      id: 'adminPanelHelmet',
      defaultMessage: 'Admin panel - {username}',
    },
    userPanel: {
      id: 'userPanel',
      defaultMessage: 'User panel',
    },
    userPanelHelmet: {
      id: 'userPanelHelmet',
      defaultMessage: 'User panel - {username}',
    },
  });

  useEffect(() => {
    dispatch(getVocabulary({ vocabNameOrURL: STATUS_VOCABULARY_ID }));
    dispatch(getUserSchema());
  }, [dispatch]);

  return (
    <div id="page-document">
      {isManager(user) ? (
        <Helmet
          title={intl.formatMessage(messages.adminPanelHelmet, {
            username: user.fullname,
          })}
        />
      ) : (
        <Helmet
          title={intl.formatMessage(messages.userPanelHelmet, {
            username: user.fullname,
          })}
        />
      )}
      <div className="private-area">
        {!isLoggedIn && (
          <>
            {token ? (
              <Forbidden
                pathname={location.pathname}
                staticContext={staticContext}
              />
            ) : (
              <Unauthorized
                pathname={location.pathname}
                staticContext={staticContext}
              />
            )}
          </>
        )}
        {isLoggedIn && (
          <>
            <div
              className={cx(
                'private-area-header',
                isManager(user) ? 'manager' : 'user',
              )}
            >
              {/* <h1 className="no-breadcrumb">
                {isManager(user) ? (
                  <FormattedMessage
                    id="Admin panel"
                    defaultMessage="Admin panel"
                  />
                ) : (
                  <FormattedMessage
                    id="User panel"
                    defaultMessage="User panel"
                  />
                )}
              </h1> */}
              <h1>{user.fullname}</h1>
            </div>
            <div className="private-area blocks-group-wrapper">
              {isManager(user) ? (
                <Manager intl={intl} dispatch={dispatch} location={location} />
              ) : (
                <User intl={intl} dispatch={dispatch} location={location} />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PrivateAreaView;
